module.exports = __webpack_public_path__ + "img/product1.4ef7155f.png";